<template>
    <div>
        <flCabecalhoForm :msg="_traducao('global','obrigatorio')" cls="print-titulo-form-20" :texto="_traducao('global', 'emergencia')" />

        <div class="row">

            <!--  TIPO SANGUINEO -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.tipo_sanguineo != ''}">
                <label><span class="no-print">* </span>{{_traducao('menuAGcadAluno', 'tipoSanguineo')}}:</label>
                <select  v-model="form.tipo_sanguineo" class="form-control input-sm">
                    <option value="">{{_traducao('global', 'escolha').toUpperCase()}}</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="AB">AB</option>
                    <option value="O">O</option>
                </select> 
                <p class="help-block" v-show="erro.tipo_sanguineo != ''">{{erro.tipo_sanguineo}}</p>
            </div>

            <!-- FATOR RH -->
            <div class="col-xs-12 col-md-3 form-group" :class="{'has-error' : erro.fator_rh != ''}">
                <label><span class="no-print">* </span>{{_traducao('menuAGcadAluno', 'fatorRH')}}:</label>
                <select v-model="form.fator_rh" class="form-control input-sm">
                    <option value="">{{_traducao('global', 'escolha').toUpperCase()}}</option>
                    <option value="+">+ ({{_traducao('global', 'positivo')}})</option>
                    <option value="-">- ({{_traducao('global', 'negativo')}})</option>
                </select>  
                <p class="help-block" v-show="erro.fator_rh != ''">{{erro.fator_rh}}</p>
            </div>

            <!-- ALERGIA -->
            <div class="col-xs-12 col-md-3 form-group">
                <label>{{_traducao('global', 'alergia')}}:</label> 
                <input v-model="form.alergia" class="form-control input-sm" />
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data () {
        return {
            form: {
                tipo_sanguineo: '',
                fator_rh: '',
                alergia: ''
            },

            erro: {
                tipo_sanguineo: '',
                fator_rh: ''
            }
        }
    },

    methods: {
        editar (item) {
            this.form.tipo_sanguineo = item.tipo_sanguineo
            this.form.fator_rh = item.fator_rh
            this.form.alergia = item.alergia

        },
        validaForm () {
            let passou = true
            let obg = this._traducao('global', 'campoObrigatorio')

            if(this.form.tipo_sanguineo == ''){
                this.erro.tipo_sanguineo = obg
                passou = false

            }else{
                this.erro.tipo_sanguineo = ''
            }

            if(this.form.fator_rh == ''){
                this.erro.fator_rh = obg
                passou = false
            }else{
                this.erro.fator_rh = ''
            }

            if(passou){
                this.$emit('dados-emergencia', this.form)
            }

            return passou
        }
    }
}
</script>